"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORT_ISSUE = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.REPORT_ISSUE = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation ReportIssue($input: ReportIssueInput!) {\n    reportIssue(input: $input) {\n      issue {\n        ...ReportedIssue\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation ReportIssue($input: ReportIssueInput!) {\n    reportIssue(input: $input) {\n      issue {\n        ...ReportedIssue\n      }\n    }\n  }\n  ", "\n"])), fragments_1.REPORTED_ISSUE_FRAGMENT);
var templateObject_1;
